(function () {
  'use strict';

  var KEY = 'papajims_wishlist';
  var PAGE_URL = '/pages/wishlist';
  var HYDRATED = {};

  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path class="wl-h-outline" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M12 20.7l-1.45-1.32C5.4 14.74 2 11.66 2 7.9 2 5.1 4.2 3 6.9 3c1.6 0 3.13.74 4.1 1.92C11.97 3.74 13.5 3 15.1 3 17.8 3 20 5.1 20 7.9c0 3.76-3.4 6.84-8.55 11.48L12 20.7z"/>' +
      '<path class="wl-h-fill" fill="currentColor" d="M12 20.7l-1.45-1.32C5.4 14.74 2 11.66 2 7.9 2 5.1 4.2 3 6.9 3c1.6 0 3.13.74 4.1 1.92C11.97 3.74 13.5 3 15.1 3 17.8 3 20 5.1 20 7.9c0 3.76-3.4 6.84-8.55 11.48L12 20.7z"/>' +
    '</svg>';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      if (!Array.isArray(v)) return [];
      return v.filter(function (i) { return i && i.handle; });
    } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    render();
  }
  function has(h) { h = String(h); return read().some(function (i) { return String(i.handle) === h; }); }
  function add(it) {
    if (!it || !it.handle) return;
    var l = read();
    if (!l.some(function (i) { return String(i.handle) === String(it.handle); })) { l.push(it); save(l); }
  }
  function remove(h) { h = String(h); save(read().filter(function (i) { return String(i.handle) !== h; })); }
  function toggle(it) { if (has(it.handle)) { remove(it.handle); return false; } add(it); return true; }

  function itemFromEl(el) {
    var d = el.dataset;
    return {
      handle: d.wishlistHandle || '',
      title: d.wishlistTitle || '',
      url: d.wishlistUrl || '',
      image: d.wishlistImage || '',
      price: d.wishlistPrice || ''
    };
  }
  function setData(el, data) {
    el.setAttribute('data-wishlist-handle', data.handle);
    el.setAttribute('data-wishlist-title', data.title || '');
    el.setAttribute('data-wishlist-url', data.url || '');
    el.setAttribute('data-wishlist-image', data.image || '');
    el.setAttribute('data-wishlist-price', data.price || '');
  }
  function parseHandle(href) { var m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? m[1] : ''; }
  function money(c) { return '$' + (Number(c || 0) / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var observer = null;
  var lastSig = '';

  function render() {
    var list = read();
    var count = list.length;

    document.querySelectorAll('.wishlist-count').forEach(function (e) {
      var v = count > 0 ? String(count) : '';
      if (e.textContent !== v) e.textContent = v;
      if (e.getAttribute('data-count') !== String(count)) e.setAttribute('data-count', String(count));
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = has(b.getAttribute('data-wishlist-handle'));
      b.classList.toggle('is-wishlisted', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.hasAttribute('data-wl-managed-label')) {
        b.textContent = on ? '♥ In your wishlist' : '♡ Add to wishlist';
      }
    });

    renderPage(list);
  }

  function renderPage(list) {
    var co = document.getElementById('wishlist-page-container');
    if (!co) return;
    list = list || read();
    var wrap = co.closest ? co.closest('.wishlist-page') : null;
    var head = wrap ? wrap.querySelector('.wishlist-page__count') : null;
    if (head) head.textContent = list.length ? (list.length + (list.length === 1 ? ' item' : ' items')) : '';

    var sig = list.map(function (i) { return i.handle + (i.image ? '1' : '0'); }).join('|');
    if (sig === lastSig && co.getAttribute('data-ready') === '1') return;
    lastSig = sig;

    if (!list.length) {
      co.innerHTML =
        '<div class="wishlist-empty">' + HEART +
        '<p>Your wishlist is empty.</p>' +
        '<p><a href="/collections/all">Continue shopping &rarr;</a></p></div>';
      co.setAttribute('data-ready', '1');
      return;
    }
    var html = '<div class="wishlist-grid">';
    list.forEach(function (i) {
      html +=
        '<div class="wishlist-card">' +
          '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + esc(i.handle) + '" aria-label="Remove from wishlist">&times;</button>' +
          '<a class="wishlist-card__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="wishlist-card__body">' +
            '<h3 class="wishlist-card__title"><a href="' + esc(i.url) + '">' + esc(i.title) + '</a></h3>' +
            (i.price ? '<div class="wishlist-card__price">' + esc(i.price) + '</div>' : '') +
          '</div>' +
          '<div class="wishlist-card__actions"><a class="wishlist-card__add" href="' + esc(i.url) + '">View product</a></div>' +
        '</div>';
    });
    html += '</div>';
    co.innerHTML = html;
    co.setAttribute('data-ready', '1');
    hydrate(list);
  }

  function hydrate(list) {
    list.forEach(function (i) {
      if (i.image || HYDRATED[i.handle]) return;
      HYDRATED[i.handle] = 1;
      fetch('/products/' + encodeURIComponent(i.handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          var cur = read(), f = null;
          for (var k = 0; k < cur.length; k++) { if (String(cur[k].handle) === String(i.handle)) { f = cur[k]; break; } }
          if (!f) return;
          if (img) f.image = img;
          if (!f.title && p.title) f.title = p.title;
          if (!f.price && p.price != null) f.price = money(p.price);
          try { localStorage.setItem(KEY, JSON.stringify(cur)); } catch (e) {}
          lastSig = ''; renderPage(cur);
        }).catch(function () {});
    });
  }

  function toast(msg) {
    var t = document.getElementById('wishlistToast');
    if (!t) { t = document.createElement('div'); t.id = 'wishlistToast'; t.className = 'wishlist-toast'; (document.body || document.documentElement).appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  function injectHeader() {
    var ul = document.querySelector('#nav-user ul[data-type="user-nav"]') || document.querySelector('#nav-user ul');
    if (!ul || ul.querySelector('.wishlist')) return;
    var li = document.createElement('li');
    li.className = 'wishlist';
    li.innerHTML =
      '<a href="' + PAGE_URL + '" class="wishlist-nav-link" aria-label="Wishlist">' +
        '<svg class="wishlist-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.7l-1.45-1.32C5.4 14.74 2 11.66 2 7.9 2 5.1 4.2 3 6.9 3c1.6 0 3.13.74 4.1 1.92C11.97 3.74 13.5 3 15.1 3 17.8 3 20 5.1 20 7.9c0 3.76-3.4 6.84-8.55 11.48L12 20.7z"/></svg>' +
        '<span class="wishlist-count" data-count="0"></span>' +
      '</a>';
    var cart = ul.querySelector('.cart');
    if (cart) ul.insertBefore(li, cart); else ul.appendChild(li);
  }

  function injectPdp() {
    var dataEl = document.getElementById('wishlist-current-product');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.handle) return;

    var existing = document.querySelectorAll('.wishlist-btn');
    if (existing.length) {
      existing.forEach(function (b) {
        if (!b.hasAttribute('data-wishlist-toggle')) {
          b.removeAttribute('onclick');
          try { b.type = 'button'; } catch (e) {}
          setData(b, data);
          b.setAttribute('data-wishlist-toggle', '');
          b.setAttribute('data-wl-managed-label', '');
        }
      });
      var stray = document.querySelector('.wishlist-pdp-wrap');
      if (stray && stray.parentNode) stray.parentNode.removeChild(stray);
      return;
    }

    if (document.querySelector('.wishlist-pdp-btn')) return;
    var addBtn = document.querySelector('.add-cart-btn') || document.querySelector('form.product-form .add-to-cart-btn') || document.querySelector('.add-to-cart-btn');
    if (!addBtn) return;
    var wrap = document.createElement('div');
    wrap.className = 'wishlist-pdp-wrap';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-pdp-btn';
    setData(btn, data);
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.innerHTML = HEART + '<span class="wl-label-add">Add to wishlist</span><span class="wl-label-remove">In your wishlist</span>';
    wrap.appendChild(btn);
    var host = addBtn.closest('.action-buttons') || addBtn;
    if (host.parentNode) host.parentNode.insertBefore(wrap, host.nextSibling);
  }

  function injectCards() {
    var SEL = '.product-card, .product-card-wrapper, .grid-product, .product-item';
    document.querySelectorAll(SEL).forEach(function (card) {
      if (card.querySelector('.wishlist-heart')) return;
      if (card.classList.contains('placeholder-product')) return;
      if (card.closest('form')) return;
      if (card.closest('[class*="cart"], [id*="cart"]')) return;
      if (card.closest('.wishlist-page')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var handle = parseHandle(link.getAttribute('href'));
      if (!handle) return;
      var host = card.querySelector('figure') || card;
      try { if (getComputedStyle(host).position === 'static') host.style.position = 'relative'; } catch (e) {}
      var titleEl = card.querySelector('.product-title, h3 a, h3, .card__title');
      var priceEl = card.querySelector('.product-price, .s1pr, .price');
      var img = card.querySelector('img');
      var isrc = img ? (img.currentSrc || img.src || '') : '';
      if (isrc.indexOf('data:') === 0) isrc = '';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wishlist-heart';
      btn.setAttribute('data-wishlist-toggle', '');
      btn.setAttribute('data-wishlist-handle', handle);
      btn.setAttribute('data-wishlist-title', (titleEl ? titleEl.textContent : (link.getAttribute('aria-label') || handle)).replace(/\s+/g, ' ').trim());
      btn.setAttribute('data-wishlist-url', (link.getAttribute('href') || '').split('?')[0]);
      btn.setAttribute('data-wishlist-image', isrc);
      var priceTxt = '';
      if (priceEl) { var ps = priceEl.querySelector('span'); priceTxt = (ps || priceEl).textContent.replace(/\s+/g, ' ').trim(); }
      btn.setAttribute('data-wishlist-price', priceTxt);
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = HEART;
      host.appendChild(btn);
    });
  }

  function refresh() {
    if (observer) observer.disconnect();
    try { injectHeader(); injectPdp(); injectCards(); render(); }
    finally { if (observer && document.body) observer.observe(document.body, { childList: true, subtree: true }); }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('[data-wishlist-toggle]');
    if (t) {
      e.preventDefault();
      e.stopPropagation();
      var on = toggle(itemFromEl(t));
      t.classList.remove('wl-animate'); void t.offsetWidth; t.classList.add('wl-animate');
      toast(on ? 'Added to wishlist' : 'Removed from wishlist');
      return;
    }
    var r = e.target.closest('[data-wishlist-remove]');
    if (r) { e.preventDefault(); remove(r.getAttribute('data-wishlist-remove')); toast('Removed from wishlist'); }
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) { lastSig = ' '; render(); } });

  function boot() {
    if (window.MutationObserver && !observer) {
      var deb;
      observer = new MutationObserver(function (muts) {
        var added = false;
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { added = true; break; } }
        if (!added) return;
        clearTimeout(deb); deb = setTimeout(refresh, 250);
      });
    }
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', function () { setTimeout(refresh, 300); });
  setTimeout(refresh, 1200);
  setTimeout(refresh, 3000);

  window.PapaJimsWishlist = { add: add, remove: remove, toggle: toggle, get: read, has: has, refresh: refresh };
})();

/* Load the mobile footer accordion module from the same /assets/ folder */
(function () {
  try {
    var base = (document.currentScript && document.currentScript.src) || '';
    if (!base) { var ss = document.querySelectorAll('script[src*="wishlist.js"]'); base = ss.length ? ss[ss.length - 1].src : ''; }
    if (!base) return;
    var url = base.split('?')[0].replace(/wishlist\.js$/, 'pj-footer.js');
    if (url.indexOf('pj-footer.js') === -1) return;
    var s = document.createElement('script'); s.src = url; s.defer = true;
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
})();
